import { AxiosResponse } from 'axios'
import axiosInstance from './http-common'

export interface SearchResult {
  name: string
  path: string
  totalSize: number
  lastModified: string
}

export interface Project {
  name: string
  totalSize: number
  lastModified: string
}

export interface ProjectStructure {
  name: string
  totalSize: number
  lastModified: string
  folders: ProjectStructure[]
}
export interface ProjectsResponse {
  projects: Project[]
}

class ProjectService {
  async listProjects(org: string): Promise<ProjectsResponse> {
    return (await axiosInstance.get(`/${org}/projects`))?.data
  }

  async listProjectsStructure(org: string): Promise<ProjectStructure[]> {
    return (await axiosInstance.get(`/${org}/structure`))?.data
  }

  addProject = async (organization: string, name: string): Promise<any> => {
    return (await axiosInstance.post(`/${organization}/projects`, { name: name })).data
  }

  // async downloadProject(org: string, name: string): Promise<any> {
  //   return (
  //     await axiosInstance.get(`/${org}/projects/download/${name}`, {
  //       responseType: 'blob',
  //     })
  //   )?.data
  // }

  async downloadProject(org: string, name: string): Promise<AxiosResponse<Blob>> {
    return axiosInstance.get(`/${org}/projects/download/${name}`, {
      responseType: 'blob',
    })
  }

  duplicateProject = async (organization: string, name: string): Promise<any> => {
    return (await axiosInstance.post(`/${organization}/projects/duplicate/${name}`)).data
  }

  renameProject = async (organization: string, name: string, newName: string): Promise<any> => {
    return (await axiosInstance.put(`/${organization}/projects/rename/${name}`, { newName: newName })).data
  }

  async getProjectContents(org: string, name: string): Promise<Project[]> {
    return (await axiosInstance.get(`/${org}/projects/${name}`))?.data
  }

  deleteProject = async (organization: string, name: string): Promise<any> => {
    return (await axiosInstance.delete(`/${organization}/projects/${name}`)).data
  }

  //search
  async getSearchResults(org: string, filter: string): Promise<{ result: SearchResult[] }> {
    return (
      await axiosInstance.get(`/${org}/search`, {
        params: {
          filter: filter,
        },
        paramsSerializer: { indexes: null },
      })
    )?.data
  }
}

export default new ProjectService()
